// Copyright © 2019 3D Robotics. All rights reserved.

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export * from '@fortawesome/free-solid-svg-icons'
export const Icon = FontAwesomeIcon;
